import { SphereTemplate, SphereTemplateResponse } from 'types';

import { api } from './setupApi';

class TemplateSettingsModel {
  link = '/sphere_templates';

  getSettings = () => api.get<{sphereTemplates: SphereTemplate[]}>(this.link).then(({ data }) => data);

  saveSettings = (templateSettings: SphereTemplate): Promise<SphereTemplateResponse> =>
    api.post(`${this.link}`, { sphereTemplate: templateSettings }).then(({ data }) => data);

  updateSettings = (templateSettings: SphereTemplate): Promise<SphereTemplateResponse> =>
    api.put(`${this.link}/${templateSettings.id}`, { sphereTemplate: templateSettings }).then(({ data }) => data);
}

export const templateSettingsModel = new TemplateSettingsModel();
